import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { joinCustomerNames } from "../../../../../services/customersService";

export function MergeSharesDialog({ open, onClose, selectedCustomerIds, customers, onConfirm }) {
    const { t } = useTranslation();
    const [mergeSelectedIds, setMergeSelectedIds] = useState([]);

    const toggleMergeSelect = (id) => {
        setMergeSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
        );
    };

    const handleConfirm = () => {
        if (mergeSelectedIds.length >= 2) {
            onConfirm(mergeSelectedIds);
        }
        setMergeSelectedIds([]);
        onClose();
    };

    const labelForId = (id) => {
        const c = customers.find((x) => x.id === id);
        return joinCustomerNames([c].filter(Boolean)) || id;
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("agreements.customersData.mergeShares")}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 1 }}>
                    {t("agreements.customersData.mergeSelectInfo")}
                </Typography>
                <Grid container direction="column">
                    {selectedCustomerIds.map((id) => (
                        <FormControlLabel
                            key={id}
                            control={
                                <Checkbox
                                    checked={mergeSelectedIds.includes(id)}
                                    onChange={() => toggleMergeSelect(id)}
                                />
                            }
                            label={labelForId(id)}
                        />
                    ))}
                    {selectedCustomerIds.length === 0 && (
                        <Typography color="text.secondary">
                            {t("agreements.customersData.noMergeCandidates")}
                        </Typography>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t("common.cancel")}</Button>
                <Button
                    variant="contained"
                    onClick={handleConfirm}
                    disabled={mergeSelectedIds.length < 2}
                >
                    {t("common.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
